import React, { Component } from 'react';
import {
  Text,
  View,
  StyleSheet,
  Pressable,
  Image,
  Animated,
  InteractionManager,
} from 'react-native';
import {
  NEW_INVITE_NOTIFICATION,
  EDIT_EVENT_NOTIFICATION,
  NEW_EVENT_NOTIFICATION,
  MESSAGING_NEW_GROUP_MESSAGE_NOTIFICATION,
} from '../../notificationsHandlersTypes';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { OPComponent, I18n, Swipeable } from '../components';

import moment from 'moment';

const ALREADY_HILITED = {};
const SWIPE_BUTTON_WIDTH = 90;

export default class ListItem extends OPComponent {
  constructor(props) {
    super(props);

    this._unMounted = false;

    this.state = {
      hiliteColor: new Animated.Value(0),
    };
  }

  componentDidMount() {}

  componentWillUnmount() {
    this._unMounted = true;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.item.notificationId !== this.props.item.notificationId;
  }

  animateHilite(notificationId) {
    InteractionManager.runAfterInteractions(() => {
      Animated.sequence([
        Animated.spring(this.state.hiliteColor, {
          toValue: 1,
          duration: 600,
          useNativeDriver: false,
        }),
        Animated.spring(this.state.hiliteColor, {
          toValue: 0,
          duration: 800,
          useNativeDriver: false,
        }),
      ]).start();
    });
  }

  rightButtons = () => {
    return [
      <Pressable onPress={this.props.onDismiss} style={styles.removeButton}>
        <View style={styles.removeButtonInner}>
          <Image
            style={{ width: 30, height: 30, tintColor: 'white' }}
            source={require('../../../resources/icon-reject.png')}
          />
        </View>
      </Pressable>,
    ];
  };

  render() {
    let item = this.props.item;

    const dateToFormat = new Date(item.updated);
    let dateFormatted = moment(dateToFormat).fromNow();

    let newItemStyles = {};
    let hiliteStyle = {};

    if (dateFormatted === I18n.t('notifications.aFewSecondsAgo')) {
      dateFormatted = I18n.t('notifications.justNow');
      newItemStyles = styles.newItemStyles;

      // dont hilite again if notifications come in quick succession
      if (!ALREADY_HILITED[item.notificationId]) {
        ALREADY_HILITED[item.notificationId] = true;
        hiliteStyle = {
          backgroundColor: this.state.hiliteColor.interpolate({
            inputRange: [0, 1],
            outputRange: [COLOR.emphasis_rgba_0, COLOR.emphasis_rgba_10],
          }),
        };

        this.animateHilite(item.notificationId);
      }
    }

    let imageSource = null;
    let iconWidth = 0;
    let iconHeight = 0;
    let showTitle = true;
    switch (item.resource) {
      case EDIT_EVENT_NOTIFICATION:
      case NEW_EVENT_NOTIFICATION:
        imageSource = require('../../../resources/notification-icon-calendar.png');
        iconWidth = 20;
        iconHeight = 22;
        showTitle = !item.body;
        break;
      case NEW_INVITE_NOTIFICATION:
      case 'cases.newParticipant':
        imageSource = require('../../../resources/notification-icon-message.png');
        iconWidth = 22;
        iconHeight = 17;
        break;
      case MESSAGING_NEW_GROUP_MESSAGE_NOTIFICATION:
        imageSource = require('../../../resources/notification-icon-chat.png');
        iconWidth = 23;
        iconHeight = 22;
        break;
      default:
        imageSource = require('../../../resources/notification-icon-alert.png');
        iconWidth = 24;
        iconHeight = 23;
        break;
    }

    if (!item.payload || !item.payload.notification) return null;

    let notification = item.payload.notification;

    return (
      <Swipeable rightButtons={this.rightButtons()} rightButtonWidth={SWIPE_BUTTON_WIDTH}>
        <Animated.View style={hiliteStyle}>
          <Pressable style={[styles.container, newItemStyles]} onPress={this.props.onPress}>
            <View style={styles.iconAndDateContainer}>
              <Image style={{ width: iconWidth, height: iconHeight }} source={imageSource} />
              <Text style={styles.timestamp}>{dateFormatted}</Text>
            </View>
            <View style={styles.textContainer}>
              {!!notification.title && !!showTitle && (
                <Text style={styles.textRegular}>{notification.title.toString()}</Text>
              )}
              {!!notification.body && (
                <Text style={styles.notificationBody}>{notification.body.toString()}</Text>
              )}
            </View>
          </Pressable>
        </Animated.View>
      </Swipeable>
    );
  }
}

const styles = StyleSheet.create({
  removeButton: THEME.removeButton,
  removeButtonInner: Object.assign({}, THEME.removeButtonInner, {
    width: SWIPE_BUTTON_WIDTH,
  }),
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch',
    borderBottomColor: COLOR.accent,
    borderBottomWidth: 1,
    paddingVertical: 20,
    paddingLeft: 10,
  },
  newItemStyles: {
    borderLeftWidth: 5,
    paddingLeft: 5,
    borderColor: COLOR.emphasis,
  },
  iconAndDateContainer: {
    width: __WEB__ ? 140 : 100,
    justifyContent: 'center',
    alignItems: 'center',
  },
  timestamp: {
    ...FONT.regularItalic,
    fontSize: FONT_SIZE.tiny,
    color: COLOR.text,
    marginTop: 2,
    textAlign: 'center',
  },
  textContainer: {
    flex: 1,
    paddingRight: 20,
    paddingLeft: 10,
    justifyContent: 'center',
  },
  textRegular: THEME.textRegular,
  notificationBody: Object.assign({}, THEME.textRegular, {
    marginTop: 10,
  }),
});
